module.exports = __webpack_public_path__ + "static/illustration-about-2-a09538315fb4b7170a637fd5f37a8cef.svg";